import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

// Angular Material
import { MatSnackBarModule } from '@angular/material/snack-bar';

// Components
import { PdfBulkDownloadComponent } from './pdf-bulk-download/pdf-bulk-download.component';
import { RetryFailedEntitiesComponent } from './retry-failed-entities/retry-failed-entities.component';
import { NewProformaDashboardComponent } from './new-proforma-dashboard/new-proforma-dashboard.component';

// Services
import { PdfBulkDownloadService } from './pdf-bulk-download/pdf-bulk-download.service';
import { RetryFailedEntitiesService } from './retry-failed-entities/retry-failed-entities.service';

@NgModule({ declarations: [
        PdfBulkDownloadComponent,
        RetryFailedEntitiesComponent,
        NewProformaDashboardComponent
    ],
    exports: [
        PdfBulkDownloadComponent,
        RetryFailedEntitiesComponent,
        NewProformaDashboardComponent
    ], imports: [CommonModule,
        FormsModule,
        MatSnackBarModule], providers: [
        PdfBulkDownloadService,
        RetryFailedEntitiesService
    ] })
export class NewProformaModule { }
